import { RecipeFormValues } from '@ordersnproducts/modules/order-builder/modules/retail-specification/models/form-values';
import {
  TopLocationActions,
  TopLocationActionTypes,
} from '@ordersnproducts/modules/new-repeat-order/modules/rms-top-location/actions/top-location.actions';
import { ValidatorFn } from '@angular/forms';
import { PurchaseOrderAsyncErrors } from '@ordersnproducts/modules/order-builder/modules/location/models/purchase-order-async-errors';
import {
  TopLocationPurchaseOrderActions,
  TopLocationPurchaseOrderActionTypes,
} from '../actions/purchase-order-actions/purchase-order.actions';

export interface TopLocationFormState {
  forms: RecipeFormValues[];
  purchaseOrder: PurchaseOrderState;
}
export interface PurchaseOrderState {
  required: boolean;
  disabled: boolean;
  validators: ValidatorFn[];
  validating: boolean;
  validationEnded: boolean;
  validMasks: string[];
  errors: PurchaseOrderAsyncErrors;
}

export const initialPO: PurchaseOrderState = {
  required: false,
  disabled: false,
  validators: [],
  validating: false,
  validationEnded: false,
  validMasks: [],
  errors: null,
};
export const initialState: TopLocationFormState = {
  forms: [],
  purchaseOrder: initialPO,
};

export let formCounter = -1;

/**
 * Adds an item to the recipe
 */
const makeRecipeItem = (values: { [key: string]: any }): RecipeFormValues => {
  const id = ++formCounter;
  return {
    id: id,
    values: { ...values },
  };
};

export function rmsSpecificationFormReducer(
  state = initialState,
  action: TopLocationActions | TopLocationPurchaseOrderActions,
): TopLocationFormState {
  switch (action.type) {
    case TopLocationActionTypes.ADD_ITEM: {
      return {
        ...state,
        forms: [makeRecipeItem(action.payload), ...state.forms],
      };
    }
    case TopLocationActionTypes.UPDATE_ITEM: {
      return {
        ...state,
        forms: state.forms.map(item => {
          if (item.id === action.payload.id) {
            return {
              ...action.payload,
              values: {
                ...action.payload.values,
              },
            };
          } else {
            return item;
          }
        }),
      };
    }
    case TopLocationActionTypes.RESET: {
      formCounter = -1;
      return {
        ...initialState,
      };
    }

    /* PURCHASE ORDER ACTIONS */
    case TopLocationPurchaseOrderActionTypes.VALIDATE_START: {
      return {
        ...state,
        purchaseOrder: {
          ...state.purchaseOrder,
          validating: true,
          validationEnded: false,
        } as PurchaseOrderState,
      };
    }
    case TopLocationPurchaseOrderActionTypes.VALIDATE_END: {
      return {
        ...state,
        purchaseOrder: {
          ...state.purchaseOrder,
          validating: false,
        } as PurchaseOrderState,
      };
    }
    case TopLocationPurchaseOrderActionTypes.VALIDATION_ENDED: {
      return {
        ...state,
        purchaseOrder: {
          ...state.purchaseOrder,
          validationEnded: true,
        } as PurchaseOrderState,
      };
    }
    case TopLocationPurchaseOrderActionTypes.MANDATORY_PO: {
      return {
        ...state,
        purchaseOrder: {
          ...state.purchaseOrder,
          disabled: false,
          errors: null,
          required: action.payload,
        } as PurchaseOrderState,
      };
    }
    case TopLocationPurchaseOrderActionTypes.SET_MASKS: {
      return {
        ...state,
        purchaseOrder: {
          ...state.purchaseOrder,
          validMasks: action.payload,
        } as PurchaseOrderState,
      };
    }
    case TopLocationActionTypes.UPDATE_POD_REPEAT: {
      state.forms[0].values.pointOfDelivery = action.pod;
      return {
        ...state,
      };
    }

    default: {
      return state;
    }
  }
}
